/*eslint-disable*/
// =======================================================
//                   Imports
// =======================================================
import React, { useState, useEffect, useRef, useContext } from "react";

import CustomAdvanceEnquiryFilter from "../../components/CustomAdvanceEnquiryFilter";

import MaterialTable from "material-table";

import FlatList from "flatlist-react";

import { useSelector, useDispatch } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";

import { Typography } from "@material-ui/core";

import { STYLES, features } from "config";

import moment from "moment";
import Material_React_Table from "../../components/Custom-React_Material-Table-Enquiry";
import CircularLoading from "../../components/CircularLoading";

import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";

// =======================================================
//                    Styles
// =======================================================

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    gap: "20px",
  },
  filter: {
    width: "100%",
  },

  listingsContainer: {
    backgroundColor: "white",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "100%",
    display: "grid",
    gap: "1px",
    alignItems: "center",
    justifyContent: "center",
    gridTemplateColumns: "repeat(auto-fill, minmax(600px, 1fr))"
  },

  listingsTable: {
    backgroundColor: "white",
    borderRadius: "4px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "100%",
    display: "grid",
    gap: "1px",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },

  EnquiryContainer: {
    gap: "10px",
    padding: "15px",
    backgroundColor: "white",
    margin: "10px 0",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.4)",
    height: "380px",
    width: "95%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
    cursor: "pointer",

  },

  listingImageSections: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    flexDirection: "column",
  },

  listingImage: {
    height: "100%",
    width: "100%",
    aspectRatio: "16/9", // Set the aspect ratio to 1:1
  },

  imageBannar: {
    gap: "4px",
    backgroundColor: "rgba(22,22,22,0.8)",
    width: "100%",
    alignContent: "center",
    justifyContent: "center",
    display: "flex",
  },

  numberFont: {
    fontSize: 16,
    color: "white",
    marginLeft: 2,
  },

  discriptionSection: {
    display: "flex",
    alignContent: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    width: "95%",
    height: "95%",
  },

  discriptionRow: {
    margin: "10px 0 0 1px",
  }


};


const columnsReactMaterialTable = [
  {
    accessorKey: 'CompanyName',
    header: 'Company',
    Cell: ({ cell }) => cell.getValue() || <em>null</em>,
  },
  {
    accessorKey: 'PhoneNumber',
    header: 'Mobile',
    Cell: ({ cell }) => <div>{cell.getValue()}</div>,
  },
  {
    accessorKey: 'Email',
    header: 'Email',
    Cell: ({ cell }) => <div>{cell.getValue()}</div>,
  },
  {
    accessorKey: 'OwnerName',
    header: 'Client',
  },
  {
    accessorKey: 'markedDate',
    header: 'Listed date',
    Cell: ({ cell }) => <div>{cell.getValue()}</div>,
  },
  {
    accessorKey: 'userdetials',
    header: 'Broker Name',
    Cell: ({ row }) => {
      const details = row.original.userdetials;
      return (
        <div>
          {details?.Name || 'N/A'} {details?.lastName || ''}
        </div>
      );
    },
  },
  {
    accessorKey: 'address.suburb',
    header: 'Areas',
    Cell: ({ row }) => <div>{row.original.address?.suburb || 'N/A'}</div>,
  },
  {
    accessorKey: 'typeOfProperty',
    header: 'Property Type',
  },
  {
    accessorKey: 'sizeMin',
    header: 'Min Size',
    Cell: ({ cell, row }) =>
      features.AllowCriticalEditsAdmin ? cell.getValue() : 'Hidden for Demo',
  },
  {
    accessorKey: 'sizeMax',
    header: 'Max Size',
    Cell: ({ cell, row }) =>
      features.AllowCriticalEditsAdmin ? cell.getValue() : 'Hidden for Demo',
  },
  {
    accessorKey: 'type',
    header: 'Type',
  },
];


const columns = [
  {
    title: "Company",
    field: "CompanyName",
    initialEditValue: "",
    emptyValue: () => <em>null</em>,
  },
  {
    title: "Mobile",
    field: "PhoneNumber",
    initialEditValue: "",
    render: (rowData) => <div>{rowData.PhoneNumber}</div>,
    customExport: (rowData) => { },
  },
  {
    title: "Email",
    field: "Email",
    initialEditValue: "",
    render: (rowData) => <div>{rowData.Email}</div>,
    customExport: (rowData) => { },
  },
  { title: "Client", field: "OwnerName", initialEditValue: "" },
  {
    title: "Listed date",
    field: "markedDate",
    initialEditValue: "",
    render: (rowData) => <div>{rowData.markedDate}</div>,
    customExport: (rowData) => { },
  },
  {
    title: "Broker Name",
    field: "userdetials.Name",
    render: (rowData) => (
      <div>
        {" "}
        {rowData.userdetials?.Name} {rowData.userdetials?.lastName}
      </div>
    ),
    export: true,
    customExport: (rowData) => {
      const name = rowData.userdetials?.Name || "N/A";
    },
  },
  // { title: "Area", field: "address.suburb", initialEditValue: "" },
  {
    title: "Areas", // New column for areas
    field: "address.suburb",
    initialEditValue: "",
    render: (rowData) => <div>{rowData.address?.suburb || "N/A"}</div>,
    customExport: (rowData) => rowData.address?.suburb || "N/A",
    export: true,
  },
  { title: "Property Type", field: "typeOfProperty", initialEditValue: "" },
  {
    title: "Min Size",
    field: "sizeMin",
    editable: "onAdd",
    render: (rowData) =>
      features.AllowCriticalEditsAdmin ? rowData.sizeMin : "Hidden for Demo",
  },
  {
    title: "Max Size",
    field: "sizeMax",
    editable: "onAdd",
    render: (rowData) =>
      features.AllowCriticalEditsAdmin ? rowData.sizeMax : "Hidden for Demo",
  },

  { title: "Type", field: "type", initialEditValue: "" },
];

import { FirebaseContext } from "common";
import { Unarchive } from "@mui/icons-material";

const StaffEnquiries = () => {

  //const declared for the screen
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const displayType = location.state || null;
  const { api } = useContext(FirebaseContext);
  const auth = useSelector((state) => state.auth.info);

  const [filteredEnquiries, setFilteredEnquiries] = useState([])
  const {
    UpdateEnquiry,
    ArchiveEnquiry,
    ViewedEnquiry,
    UnreadEnquiry, //added this action to mark an enquiry as unread
    MatchListingToEnquiry,
    AddEnquiryToCallList,
    addtoEnquiryTimeline,
    fetchCurrentAdminsBranchEnquiries,
    RemoveEnquiryFromCallList,
    fetchformEnquiryTimeline,
    fetchUserEnquiryhistory,
    UnarchiveEnquiry,
    SendPushNotification,
    clearEnquiryErrors,
    clearPullforwardEnquirySuccess,
    AddEnquiryToWhiteboard,
    AddEnquiryToInvestor,
  } = api;


  const [view, setView] = useState('table');
  const [currentEnquries, setCurrentEnquiries] = useState([])
  const [displayedEnquiries, setDisplatedEnquiries] = useState([]);
  const [loading, setLoading] = useState({ isloading: false, reason: "" });
  const enquiryManagementReducer = useSelector((state) => state.enquirydata);

  /*=============================================
  =            Use Effects            =
  =============================================*/

  useEffect(() => {
    // Fetch all listings when the component mounts
    console.log('listingMan', enquiryManagementReducer)
    setCurrentEnquiries([]);
    if (displayType === "Active") {
      setCurrentEnquiries(enquiryManagementReducer.activeBranchEnquiries);
    }

    if (displayType === "inActive") {
      setCurrentEnquiries(enquiryManagementReducer.inactiveBranchEnquiries);
    }

    if (displayType !== "Active" && displayType !== "inActive") {
      setCurrentEnquiries([...enquiryManagementReducer.activeBranchEnquiries, ...enquiryManagementReducer.inactiveBranchEnquiries]);
    }

    if (Array.isArray(displayType)) {
      setCurrentEnquiries(displayType)
    }

  }, [enquiryManagementReducer])

  //consts
  const userName = `${auth?.profile?.firstName} ${auth?.profile?.lastName}`;

  function archive(enquiry) {

    dispatch(
      UpdateEnquiry({
        ...enquiry,
        archive: new Date().getTime() + 1209600000,
        status: "inActive",
      })
    );
    dispatch(
      addtoEnquiryTimeline(enquiry, {
        time: Date.now(),
        title: `${userName} archived enquiry for all`,
      })
    );
    dispatch(fetchCurrentAdminsBranchEnquiries())
  }

  function navigateToCreateEnquiry() {
    dispatch(clearEnquiryErrors())
    navigate("/createEnquiry");
  }

  function unArchive(enquiry) {

    dispatch(
      UpdateEnquiry({
        ...enquiry,
        status: "Active",
      })
    );
    dispatch(
      addtoEnquiryTimeline(enquiry, {
        time: Date.now(),
        title: `${userName} unarchived enquiry for all`,
      })
    );
    dispatch(fetchCurrentAdminsBranchEnquiries())
  }

  function pullforward(enquiry) {

    navigate("/staffpullforward", { state: { item: enquiry } });

  }

  function edit(enquiry) {
    navigate("/updateEnquiry", { state: { enquiry } });

  }

  const RenderItem = (item) => {

    const dropdownRef = useRef();
    const [dropUp, setDropUp] = useState(false);
    //This useEffect needs to be in the DOM
    useEffect(() => {
      //Fuction to check the position of the dropdown
      const checkDropdownPosition = () => {
        if (dropdownRef.current) {
          const rect = dropdownRef.current.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          // Check if the dropdown is close to the bottom of the viewport
          const distanceFromBottom = windowHeight - rect.bottom;
          setDropUp(distanceFromBottom < 200);
        }
      };

      checkDropdownPosition();
      // Add event listeners for scroll and resize to check dropdown position
      window.addEventListener("scroll", checkDropdownPosition);
      window.addEventListener("resize", checkDropdownPosition);

      // Cleanup event listeners on component unmount
      return () => {
        window.removeEventListener("scroll", checkDropdownPosition);
        window.removeEventListener("resize", checkDropdownPosition);
      };
    }, []);

    return (
      <div style={styles.EnquiryContainer} ref={dropdownRef}>
        <div style={styles.discriptionSection} onClick={() => {
          navigate("/staffenquirydetails", { state: { item } });
        }}>
          <div style={{ marginBottom: 15 }}>
            <Typography
              variant="h5"
              style={{ margin: "20px0 15px", color: STYLES.TERTIARY_APP_CLR }}
            >
              {item?.type === "sale" || item?.type?.includes("For Sale")
                ? "Looking To Buy"
                : item?.type === "tolet" || item?.type?.includes("To Let")
                  ? "Looking To Rent"
                  : "Looking To Buy or Rent"}
            </Typography>
          </div>




          <div style={styles.discriptionRow}>
            <span
              style={{
                fontSize: 18,
                fontWeight: "600",
                margin: "10px 0 0 1px",
                color: STYLES.SECONDARY_APP_CLR,
              }}
            >
              Property Size:{" "}
            </span>
            {/* <p className="description">{Booking.eventDate}</p> */}
            <span
              style={{
                fontSize: 16,
                margin: "10px 0 0 1px",
              }}
            >  {item.sizeMin} - {item.sizeMax}㎡
            </span>
          </div>



          <div style={styles.discriptionRow}>
            <span
              style={{
                fontSize: 18,
                fontWeight: "1000",
                margin: "10px 0 0 1px",
                color: STYLES.SECONDARY_APP_CLR,
              }}
            >
              Company:{" "}
            </span>
            {/* <p className="description">{Booking.serviceType}</p> */}
            <span
              style={{
                fontSize: 16,
                margin: "10px 0 0 1px",
              }}
            >{item?.CompanyName}{" "}</span>
          </div>

          <div style={styles.discriptionRow}>
            <span
              style={{
                fontSize: 18,
                fontWeight: "600",
                margin: "10px 0 0 1px",
                color: STYLES.SECONDARY_APP_CLR,
              }}
            >
              Area:{" "}
            </span>
            <span
              style={{
                fontSize: 16,
                margin: "10px 0 0 1px",
              }}
            > {item?.suburbs
              ? item?.suburbs?.length > 0
                ? `${item?.suburbs}`.substring(0, 100).trim() + `...`
                : "N/A"
              : "N/A"}
            </span>
          </div>



          <div style={styles.discriptionRow}>
            <span
              style={{
                fontSize: 18,
                fontWeight: "600",
                margin: "10px 0 0 1px",
                color: STYLES.SECONDARY_APP_CLR,
              }}
            >
              Property Type:{" "}
            </span>
            {/* <p className="description">{Booking.eventDate}</p> */}
            <span
              style={{
                fontSize: 16,
                margin: "10px 0 0 1px",
              }}
            >{item.typeOfProperty}{" "}
            </span>
          </div>



          <div style={styles.discriptionRow}>
            <span
              style={{
                fontSize: 18,
                fontWeight: "600",
                margin: "10px 0 0 1px",
                color: STYLES.SECONDARY_APP_CLR,
              }}
            >
              Broker:{" "}
            </span>
            {/* <p className="description">{Booking.eventDate}</p> */}
            {item.userdetials.Name} {item.userdetials.lastName}{" "}
          </div>

          <div style={styles.discriptionRow}>
            <span
              style={{
                fontSize: 18,
                fontWeight: "600",
                margin: "10px 0 0 1px",
                color: STYLES.SECONDARY_APP_CLR,
              }}
            >
              Enquiry Date:{" "}
            </span>
            {/* <p className="description">{Booking.eventDate}</p> */}
            {item.enquiryDate
              ? moment(item.enquiryDate).format("MMMM Do YYYY HH:mm:ss")
              : "N/A"}
          </div>





        </div>


        <div>
          <UncontrolledDropdown direction={dropUp ? "up" : "down"}>
            <DropdownToggle
              className="btn-round btn-icon"
              color="default"
              outline
            // style={{marginRight: spacing + 'em'}}
            >
              <i className="now-ui-icons design_bullet-list-67" />
            </DropdownToggle>
            <DropdownMenu end>
              {/* <DropdownItem>Share</DropdownItem> */}
              <DropdownItem
                onClick={() => {
                  edit(item);
                }}
              >Edit</DropdownItem>
              <>
                {item?.status !== "Active" ? (
                  <DropdownItem
                onClick={() => {
                  unArchive(item);
                }}
              >Unarchive</DropdownItem>
                ) : (
                  <DropdownItem
                onClick={() => {
                  archive(item);
                }}
              >Archive</DropdownItem>
                )}
              </>
              {/* <DropdownItem>Unachive</DropdownItem> */}
              <DropdownItem
                onClick={() => {
                  navigate("/staffpullforward", { state: { item } });
                }}
              >
                Pull Forward
              </DropdownItem>
              {/* <DropdownItem>Call Client</DropdownItem>
              <DropdownItem>Message Client</DropdownItem>
              <DropdownItem className="text-danger">
                Share Internally
              </DropdownItem> */}
            </DropdownMenu>
          </UncontrolledDropdown>


        </div>
      </div>
    );
  };



  function RenderFlatlist() {
    return (
      <FlatList
        keyExtractor={(item, index) => {
          return index.toString();
        }}
        list={displayedEnquiries}
        renderOnScroll
        renderItem={(item) => {
          return <RenderItem {...item} />;
        }}
        renderWhenEmpty={() => <div>There currently is no Enquiries!</div>}
      />

    );
  }

  function RenderTable() {
    return (

      <Material_React_Table
        data={displayedEnquiries}
        allData={filteredEnquiries.length > 0 ? filteredEnquiries : currentEnquries}
        columns={columnsReactMaterialTable}
        userInitialState={{
          columnVisibility: { id: false }, // This hides the "id" column initially
        }}
        archive={archive}
        unArchive={unArchive}
        edit={edit}
        navigateToCreateEnquiry={navigateToCreateEnquiry}
        pullforward={pullforward}
      // view={view}
      // onRowUpdate={quickEdit}
      // publish={publishListingTable}
      // api={api_website_sendTable}
      // PrivateProperty={PrivatePropertysendTable}
      // property24={Property_24}
      // editTable={editTable}
      />


    );
  }

  // function RenderTable() {
  //   return (
  //     <div style={{ width: "100%" }}>
  //       <MaterialTable
  //         title={"Enquiries"}
  //         columns={columns}
  //         data={currentEnquries}
  //         options={{
  //           sorting: true,
  //           search: true,
  //           paging: true,
  //           searchFieldAlignment: "right",
  //           searchAutoFocus: true,
  //           searchFieldVariant: "standard",
  //           filtering: true,
  //           pageSizeOptions: [2, 5, 10, 20, 25, 50, 100],
  //           pageSize: 20,
  //           paginationType: "stepped",
  //           showFirstLastPageButtons: false,
  //           paginationPosition: "both",
  //           exportButton: true,
  //           exportAllData: true,
  //           exportFileName: "TableData",
  //           addRowPosition: "first",
  //           actionsColumnIndex: -1,
  //           selection: true,
  //           showSelectAllCheckbox: false,
  //           showTextRowsSelected: false,
  //           grouping: true,
  //           columnsButton: true,
  //           rowStyle: (data, index) =>
  //             index % 2 === 0 ? { background: "#f5f5f5" } : null,
  //           headerStyle: { background: STYLES.TERTIARY_APP_CLR, color: "#fff" },
  //         }}
  //       />
  //     </div>


  //   );
  // }


  return loading.isloading || enquiryManagementReducer.loading ? (
    <CircularLoading label={loading.reason} />
  ) : (
    <div style={styles.container}>

      <div style={styles.filter}><CustomAdvanceEnquiryFilter setView={setView} setDisplayedEnquiries={setDisplatedEnquiries} filteredEnquiries={filteredEnquiries} setFilteredEnquiries={setFilteredEnquiries} currentEnquiries={currentEnquries.sort((a, b) => {
        const normalize = (value) => {
          if (typeof value === "number") {
            // Already a Unix timestamp in milliseconds
            return value;
          } else if (typeof value === "string") {
            // Parse string with moment
            return moment(value, ["DD MMM YYYY HH:mm", moment.ISO_8601]).valueOf();
          }
          return 0; // Fallback
        };

        const newA = normalize(a.CreatedAt);
        const newB = normalize(b.CreatedAt);

        return newB - newA; // Sort descending
      })}


      /> </div>

      <div style={styles.listingsContainer}> {view === "list" && <RenderFlatlist />} </div>

      <div style={styles.listingsTable}> {view === "table" && <RenderTable />} </div>

    </div>
  )
}

export default StaffEnquiries;
